import CompanyProfileForm from './company-profile-form.js'

export default CompanyProfileForm;